import { Union } from "./fable_modules/fable-library-js.4.25.0/Types.js";
import { class_type, union_type, option_type, string_type } from "./fable_modules/fable-library-js.4.25.0/Reflection.js";
import { printf, toText } from "./fable_modules/fable-library-js.4.25.0/String.js";

export class AuthPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Login", "ResetPassword", "EmailChange", "RequestPasswordReset", "Register"];
    }
}

export function AuthPage_$reflection() {
    return union_type("Client.Pages.Pages.AuthPage", [], AuthPage, () => [[], [["token", option_type(string_type)]], [["maybeCurrentEmail", option_type(string_type)], ["maybeNewEmail", option_type(string_type)], ["maybeToken", option_type(string_type)]], [], []]);
}

export function AuthPage_get_tryParse() {
    return (_arg) => ((_arg === "login") ? (new AuthPage(0, [])) : ((_arg === "resetPassword") ? (new AuthPage(1, [undefined])) : ((_arg === "emailChange") ? (new AuthPage(2, [undefined, undefined, undefined])) : ((_arg === "requestPasswordReset") ? (new AuthPage(3, [])) : ((_arg === "register") ? (new AuthPage(4, [])) : undefined)))));
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Auth", "Practices", "Users", "Invitations", "Demonstration", "UserProfile", "Packages", "Patients", "PracticeMedia", "PublicMedia", "Landing"];
    }
}

export function Page_$reflection() {
    return union_type("Client.Pages.Pages.Page", [], Page, () => [[["Item", AuthPage_$reflection()]], [], [], [], [], [], [["practiceId", class_type("System.Guid")]], [["token", option_type(string_type)]], [["practiceId", class_type("System.Guid")]], [], []]);
}

export const hashPrefix = (() => {
    const clo = toText(printf("#%s"));
    return clo;
})();

export const ofAuth = (() => {
    const clo_1 = toText(printf("%s/%s"))("auth");
    return clo_1;
})();

export function pageHash(_arg) {
    let matchResult, token, currentEmail, newEmail, token_1, practiceId, token_2, practiceId_1;
    switch (_arg.tag) {
        case 1: {
            matchResult = 7;
            break;
        }
        case 2: {
            matchResult = 8;
            break;
        }
        case 4: {
            matchResult = 9;
            break;
        }
        case 5: {
            matchResult = 10;
            break;
        }
        case 3: {
            matchResult = 11;
            break;
        }
        case 6: {
            matchResult = 12;
            practiceId = _arg.fields[0];
            break;
        }
        case 7: {
            matchResult = 13;
            token_2 = _arg.fields[0];
            break;
        }
        case 8: {
            matchResult = 14;
            practiceId_1 = _arg.fields[0];
            break;
        }
        case 9: {
            matchResult = 15;
            break;
        }
        case 10: {
            matchResult = 16;
            break;
        }
        default:
            switch (_arg.fields[0].tag) {
                case 1: {
                    if (_arg.fields[0].fields[0] != null) {
                        matchResult = 2;
                        token = _arg.fields[0].fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 3: {
                    matchResult = 3;
                    break;
                }
                case 4: {
                    matchResult = 4;
                    break;
                }
                case 2: {
                    if (_arg.fields[0].fields[0] != null) {
                        if (_arg.fields[0].fields[1] != null) {
                            if (_arg.fields[0].fields[2] != null) {
                                matchResult = 5;
                                currentEmail = _arg.fields[0].fields[1];
                                newEmail = _arg.fields[0].fields[2];
                                token_1 = _arg.fields[0].fields[0];
                            }
                            else {
                                matchResult = 6;
                            }
                        }
                        else {
                            matchResult = 6;
                        }
                    }
                    else {
                        matchResult = 6;
                    }
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return hashPrefix(ofAuth("login"));
        case 1:
            return hashPrefix(ofAuth("resetPassword"));
        case 2:
            return hashPrefix(ofAuth(toText(printf("%s?token=%s"))("resetPassword")(token)));
        case 3:
            return hashPrefix(ofAuth("requestPasswordReset"));
        case 4:
            return hashPrefix(ofAuth("register"));
        case 5:
            return hashPrefix(ofAuth(toText(printf("%s?currEmail=%s&newEmail=%s&token=%s"))("emailChange")(currentEmail)(newEmail)(token_1)));
        case 6:
            return hashPrefix(ofAuth("emailChange"));
        case 7:
            return hashPrefix("practices");
        case 8:
            return hashPrefix("users");
        case 9:
            return hashPrefix("demonstration");
        case 10:
            return hashPrefix("userProfile");
        case 11:
            return hashPrefix("invitations");
        case 12:
            return hashPrefix(`${"practices"}/${practiceId}/${"packages"}`);
        case 13:
            return hashPrefix(`${"patients"}?token=${token_2}`);
        case 14:
            return hashPrefix(`${"practices"}/${practiceId_1}/${"media"}`);
        case 15:
            return hashPrefix("media");
        default:
            return hashPrefix("landing");
    }
}

